import SpinBlock from '@/ui-kit/components/SpinBlock';
import loadable from '@loadable/component';
import { ClientOnly } from 'remix-utils/client-only';
import type { TProps } from './EnvironmentSelectWrapper';

const EnvironmentSelectWrapper = loadable(() => import('./EnvironmentSelectWrapper'), {
  fallback: <SpinBlock />,
});

type EnvironmentSelectWrapperProps = TProps;
export default function AsyncEnvironmentSelectWrapper(props: EnvironmentSelectWrapperProps) {
  return (
    <ClientOnly fallback={<SpinBlock />}>
      {() => <EnvironmentSelectWrapper {...props} />}
    </ClientOnly>
  );
}
